import { ValueOf } from 'type-fest';
/**
 * Realm/Sandbox Status Types
 *
 * Lifecycle statuses:
 * - Creating: Realm is being provisioned
 * - NotInitialized: Realm created but not yet initialized (not a failure; no Initialize retry offered)
 * - Initialized: Realm fully operational and accessible
 *
 * Failure statuses:
 * - Failed: Infrastructure/provisioning failure during creation (not recoverable via initialization)
 * - ReleaseTaskFailed: Release tasks failed before initialization was attempted (can retry initialization)
 * - InitializationFailed: Rails API initialization failed (can retry initialization)
 * - PartiallyInitialized: Some services initialized but not all (can retry to complete initialization)
 *
 * End-of-life statuses:
 * - Archived: Realm deactivated but data retained
 * - PartiallyRemoved: Realm removal in progress
 * - Removed: Realm fully removed
 */
export enum SandboxStatusTypes {
  Creating = 'Creating',
  NotInitialized = 'Not Initialized',
  Initialized = 'Initialized',
  Failed = 'Failed',
  ReleaseTaskFailed = 'Release Task Failed',
  InitializationFailed = 'Initialization Failed',
  PartiallyInitialized = 'Partially Initialized',
  Archived = 'Archived',
  PartiallyRemoved = 'Partially Removed',
  Removed = 'Removed',
}

export type SandboxStatusValues = ValueOf<typeof SandboxStatusTypes>;

// only show on Mosaic Sandbox team
export const SANDBOX_TEAM_CREDENTIALS_WARNING_MESSAGE =
  'THIS IS THE MAIN DEMO ACCOUNT DO NOT SHARE CREDENTIALS TO THIS ACCOUNT WITH CUSTOMERS';
// errors to show if sandbox team name or tag has uppercase or special characters on edit/create sandbox
export const INPUT_ERROR_MESSAGE = 'Cannot contain capital letters or special characters';
// errors to show if tag is stand by on edit/create sandbox
export const STAND_BY_TAG_ERROR_MESSAGE = 'This is a reserved tag, please use another one.';
// used for checking if is on Mosaic Sandbox team
export const MOSAIC_SANDBOX_TEAM_ID = 2848;
